import {mapActions, mapGetters} from 'vuex'

export default {
  methods: {
    ...mapActions('utils', ['changeTariff']),
    async changeCurrentTariff (tariff) {
      this.$vs.dialog({
        'title': this.$t('message.tariff.change'),
        'text': `${this.$t('message.tariff.change')} ${tariff}`,
        'color': 'warning',
        'accept': async () => {
          try {
            await this.changeTariff(tariff)
            this.$vs.notify({
              'title': this.$t('message.tariff.change'),
              'text': `${this.$t('message.tariff.wasChange')}`,
              'position': 'top-center'
            })
          } catch (e) {
            console.log(e)
          }
        }
      })
    }
  },
  computed: {
    ...mapGetters('utils', ['getTariffs', 'getTemplate', 'getUpData']),
    upData () {
      return this.getUpData
    },
    template () {
      return this.getTemplate
    },
    tariffCodeInfo () {
      const info = {}
      Object.values(this.getTariffs).forEach((item) => {
        info[item['tarif_code']] = item
      })
      return info
    },
    downData () {
      const data = {
        main: {},
        star: {}
      }
      const template = this.template
      const keys = ['main', 'star']

      const tariffsInfo = Object.values(this.getTariffs).reduce(function (carry, item) {
        return { ...carry, [item['tarif_code']]: { ...item }}
      }, {})

      keys.forEach(function (type) {
        Object.keys(template[type]).forEach(function (key) {
          if (Object.keys(data[type]).indexOf(key) === -1) {
            data[type][key] = []
          }

          template[type][key].forEach(function (item) {
            const calculatedItem = { ...item, val: null }
            if (item['valInt']) {
              calculatedItem['val'] = parseInt(tariffsInfo[key][item['valInt']], 10)
            } else if (item['valStr']) {
              calculatedItem['val'] = tariffsInfo[key][item['valStr']] || 'Нет данных'
            } else if (item['valFloat']) {
              calculatedItem['val'] = parseFloat(tariffsInfo[key][item['valFloat']]).toFixed(3)
            } else if (item['valArr']) {
              const data = []
              item['valArr'].forEach((item) => {
                if (item['valInt']) {
                  data.push(parseInt(tariffsInfo[key][item['valInt']], 10))
                } else if (item['valStr']) {
                  data.push(tariffsInfo[key][item['valStr']] || 'Нет данных')
                } else if (item['valFloat']) {
                  data.push(parseFloat(tariffsInfo[key][item['valFloat']]).toFixed(3))
                }
              })

              calculatedItem['val'] = data.join(' / ')
            }
            data[type][key].push(calculatedItem)
          })
        })
      })

      console.log(data)
      return data
    },
    downDataObj () {
      const data = {
        main: {},
        star: {}
      }
      const template = this.downData
      const keys = ['main', 'star']

      keys.forEach((type) => {
        Object.keys(template[type]).forEach(function (key) {
          template[type][key].forEach((lineData) => {
            data[type][key] = { ...data[type][key], [lineData['id']] : lineData }
          })
        })
      })

      return data
    },
    heads () {
      const data = []
      Object.keys(this.upData).forEach((key) => {
        data.push(key)
      })
      return data
    },
    compareData () {
      if (!this.upData) return {}

      const compareData = {}
      Object.keys(this.upData).forEach((key) => {
        this.upData[key].forEach((item) => {
          compareData[item] = {...compareData[item], [key]: null}
        })
      })

      const head = 'main'
      Object.keys(this.downData[head]).forEach((key) => {
        Object.keys(this.downData[head][key]).forEach((item) => {
          compareData[this.downData[head][key][item]['id']] = {
            ...compareData[this.downData[head][key][item]['id']],
            [key]: this.downData[head][key][item]
          }
        })
      })

      return compareData
    },
    compareDataStar () {
      const compareData = {}

      const head = 'star'
      Object.keys(this.downData[head]).forEach((key) => {
        Object.keys(this.downData[head][key]).forEach((item) => {
          compareData[this.downData[head][key][item]['id']] = {
            ...compareData[this.downData[head][key][item]['id']],
            [key]: this.downData[head][key][item]
          }
        })
      })

      return compareData
    }
  }
}
